var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextClipboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.9 21.8",
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "textClipboard",
    transform: "translate(0.75 0.75)",
    d: "M15.4,5H4C3.6,5,3.3,4.7,3.3,4.3S3.6,3.5,4,3.5h11.3 c0.4,0,0.8,0.3,0.8,0.7S15.8,5,15.4,5z M16.1,7.9c0-0.4-0.3-0.8-0.8-0.8H4c-0.4,0-0.8,0.3-0.8,0.8c0,0.4,0.3,0.8,0.8,0.8h11.3 C15.8,8.6,16.1,8.3,16.1,7.9z M7.3,20.9l4.6-4.2h7.5c0.4,0,0.8-0.3,0.8-0.7V0c0-0.4-0.3-0.8-0.8-0.8H0c-0.4,0-0.8,0.3-0.8,0.8v15.9 c0,0.4,0.3,0.7,0.8,0.7h6v3.6c0,0.3,0.2,0.6,0.4,0.7c0.1,0,0.2,0.1,0.3,0.1C7,21.1,7.1,21,7.3,20.9z M0.7,0.7h17.9v14.4h-7 c-0.2,0-0.4,0.1-0.5,0.2l-3.6,3.2v-2.7c0-0.4-0.3-0.8-0.8-0.8h-6V0.7z M16.1,11.4c0-0.4-0.3-0.8-0.8-0.8H4c-0.4,0-0.8,0.3-0.8,0.8 s0.3,0.8,0.8,0.8h11.3C15.8,12.2,16.1,11.8,16.1,11.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextClipboard);
export default __webpack_public_path__ + "static/media/textClipboard.3e7b977f810995d7260139a72830db4c.svg";
export { ForwardRef as ReactComponent };